import { PageRef } from 'providers/page-ref';

/** The Training Overview takes no parameters: it always shows the signed-in account's training up to today. */
export type TrainingOverviewPageParams = Record<string, never>;

export const ITrainingOverviewPage: PageRef<TrainingOverviewPageParams, void> = {
  pageName: 'TrainingOverviewPage',
} as PageRef<TrainingOverviewPageParams, void>;
